export default __webpack_public_path__ + "static/media/Hockey Stadium, PKL6.a97b68b1.jpg";